var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordWatcher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_693_2714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 5.33334V4.00001C2.6665 3.64638 2.80698 3.30724 3.05703 3.0572C3.30708 2.80715 3.64622 2.66667 3.99984 2.66667H5.33317",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 10.6667V12C2.6665 12.3536 2.80698 12.6928 3.05703 12.9428C3.30708 13.1929 3.64622 13.3333 3.99984 13.3333H5.33317",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 2.66667H11.9998C12.3535 2.66667 12.6926 2.80715 12.9426 3.0572C13.1927 3.30724 13.3332 3.64638 13.3332 4.00001V5.33334",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 13.3333H11.9998C12.3535 13.3333 12.6926 13.1929 12.9426 12.9428C13.1927 12.6928 13.3332 12.3536 13.3332 12V10.6667",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 7.33333H6.00016C5.63197 7.33333 5.3335 7.63181 5.3335 7.99999V9.99999C5.3335 10.3682 5.63197 10.6667 6.00016 10.6667H10.0002C10.3684 10.6667 10.6668 10.3682 10.6668 9.99999V7.99999C10.6668 7.63181 10.3684 7.33333 10.0002 7.33333Z",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 7.33334V6.00001C6.6665 5.64638 6.80698 5.30724 7.05703 5.0572C7.30708 4.80715 7.64622 4.66667 7.99984 4.66667C8.35346 4.66667 8.6926 4.80715 8.94265 5.0572C9.19269 5.30724 9.33317 5.64638 9.33317 6.00001V7.33334",
    stroke: "#222529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_693_2714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordWatcher);
export default __webpack_public_path__ + "static/media/passwordWatcher.eadc9b185d33d4d8ac5701c1d48eea2d.svg";
export { ForwardRef as ReactComponent };